module.exports = __webpack_public_path__ + "img/info-circle.109a439f.svg";